import React from 'react';

import { Text, Stack } from '@nerdwallet/currency';

export type PanelHeaderProps = {
  title: string;
  subtitle?: string;
};

const PanelHeader: React.FC<PanelHeaderProps> = ({ title, subtitle }) => {
  return (
    <Stack spacing="1">
      <Text bold>{title}</Text>
      {subtitle && <Text size="small">{subtitle}</Text>}
    </Stack>
  );
};

export default PanelHeader;
